<template>
  <svg class="fill-current" aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  iconClass: {
    type: String,
    required: true,
  },
})
const iconName = computed(() => `#${props.iconClass}`)
</script>
